import { Grid } from '@mui/material';
import styled from 'styled-components';

export default styled(Grid)`
  p {
    margin: 0;
  }
`;
